<template>
  <div class="content md no-padding flex-box vertical">
    <div class="form-box flex-grow scroll-area">
      <a-form-model ref="ruleForm" label-align="left" :model="form" :rules="rules" layout="vertical">
        <template v-if="step === 1">
          <a-form-model-item label="上传类别" prop="courseware">
            <a-radio-group
              v-model="form.courseware"
              :options="coursewareOptions"
              :disabled="!!(form.files && form.files.length)"
            ></a-radio-group>
          </a-form-model-item>
          <a-form-model-item :label="filesLabel" prop="files">
            <file-upload v-model="form.files" multiple dragger v-if="form.courseware === 4"></file-upload>
            <form-upload
              v-model="form.files"
              :limit="-1"
              :size="500 * 1024 * 1024"
              media-type="video"
              save-file-name
              multiple
              dragger
              custom-accept="video/*"
              v-if="form.courseware === 2"
            ></form-upload>
          </a-form-model-item>
        </template>
        <template v-if="step === 2">
          <a-form-model-item label="适用身份" prop="identity">
            <a-select v-model="form.identity" :options="roleOptions" placeholder="请选择适用身份"></a-select>
          </a-form-model-item>
          <a-form-model-item label="课程类型" prop="learn_course_type_id">
            <a-select
              v-model="form.learn_course_type_id"
              :options="typeOptions"
              placeholder="请选择课程类型"
            ></a-select>
          </a-form-model-item>
          <a-form-model-item label="学修推荐" prop="is_recommend">
            <a-switch v-model="form.is_recommend"></a-switch>
          </a-form-model-item>
        </template>
      </a-form-model>
      <a-table
        ref="dataTable"
        :columns="renderColumns"
        :data-source="list"
        row-key="key"
        class="lesson-table"
        v-if="step === 2"
      >
        <template v-slot:name="text, record">
          <a-input v-model="record.name" placeholder="请输入课程名称"></a-input>
        </template>
        <template v-slot:cover="text, record">
          <form-upload v-model="record.cover_image" :size="50 * 1024 * 1024"></form-upload>
        </template>
        <template v-slot:content="text, record">
          <div class="files-item-name" v-if="form.courseware === 4">{{ record.content }}</div>
          <video :src="record.content" class="file-item video" v-else-if="form.courseware === 2"></video>
        </template>
        <template v-slot:action="text, record, index">
          <div class="row-btn" @mousedown.stop @mouseup.stop>
            <a class="txt-btn danger" @click.stop="delRow(record, index)">删除</a>
          </div>
        </template>
      </a-table>
    </div>
    <a-space class="footer">
      <a-button @click="handleCancel">取消</a-button>
      <a-button type="primary" :loading="nextLoading" @click="handleNext" v-if="step === 1">确认</a-button>
      <a-button type="primary" :loading="confirmLoading" @click="handleConfirm" v-if="step === 2">保存</a-button>
    </a-space>
  </div>
</template>

<script>
import { staffTypes } from "../../common/hr/book";
import { directUploadTencentCloud } from "../../common/js/tencent_cloud";
import { getKeyTitle, isEmpty, randomString } from "../../common/js/tool";

const defaultForm = {
  courseware: 2, // 默认视频
  is_recommend: false,
  // files: [
  //   {
  //     url: "https://lingyin-1301841918.cos.ap-shanghai.myqcloud.com/1752061232560dW6dTTR7pCkAN7nRwtjipDAfwDEYdjsJ.mp4",
  //     name: "测试",
  //   },
  // ],
};

export default {
  name: "LessonBatch",
  data() {
    return {
      step: 1,
      form: { ...defaultForm },
      rules: {
        courseware: [{ required: true, message: "请选择上传类别", trigger: "change" }],
        files: [{ required: true, message: "请选择上传内容", trigger: "change" }],
        identity: [{ required: true, message: "请选择适用身份", trigger: "change" }],
        learn_course_type_id: [{ required: true, message: "请选择课程类型", trigger: "change" }],
        is_recommend: [{ required: true, message: "请选择学修推荐", trigger: "change", type: "boolean" }],
      },
      coursewareOptions: [
        { value: 2, label: "视频" },
        { value: 4, label: "文件" },
      ],
      roleOptions: [{ key: 0, title: "全部" }, ...staffTypes],
      typeOptions: [],
      list: [],
      nextLoading: false,
      confirmLoading: false,
    };
  },
  computed: {
    renderColumns() {
      return [
        { title: "序号", dataIndex: "rowIndex", key: "index", width: 60 },
        { title: "课程名称", key: "name", scopedSlots: { customRender: "name" } },
        { title: "封面图", key: "cover_image", scopedSlots: { customRender: "cover" }, width: 200 },
        {
          title: this.coursewareText,
          key: "content",
          scopedSlots: { customRender: "content" },
          width: 200,
        },
        { title: "操作", key: "action", fixed: "right", scopedSlots: { customRender: "action" }, width: 120 },
      ];
    },
    coursewareText() {
      return getKeyTitle(this.coursewareOptions, this.form.courseware, "value", "label") || "内容";
    },
    filesLabel() {
      return `上传${this.coursewareText}`;
    },
  },
  activated() {
    this.getTypeOptions();
    this.form = { ...defaultForm };
    this.step = 1;
  },
  methods: {
    getTypeOptions() {
      this.$axios("/admin/learn-type?pageSize=1000").then((res) => {
        this.typeOptions = res.data.map((item) => {
          return {
            value: item.id,
            label: item.name,
          };
        });
      });
    },
    delRow(item, index) {
      this.list.splice(index, 1);
    },
    createVideo(url) {
      return new Promise((resolve, reject) => {
        const video = document.createElement("video");
        video.crossOrigin = "Anonymous";
        video.src = url + `?t=${Date.now()}`;
        video.width = 200;
        video.height = 200;
        video.preload = "auto"; // 预加载视频，以保证可稳定获取画面
        video.currentTime = 0; //指定截取几秒处的帧
        video.destroy = function () {
          video?.pause();
          video.src = "";
          video.destroy = null;
          video.remove();
        };
        video.addEventListener("loadeddata", function () {
          console.log("Video loadeddata");
          resolve(video);
        });
        video.addEventListener("error", function (err) {
          console.log("Video error:", err);
          reject(err);
        });
        video.load(); // 建议添加加载调用
      });
    },
    getVideoCover(url) {
      return new Promise((resolve) => {
        this.createVideo(url)
          .then((video) => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            ctx.drawImage(video, 0, 0);
            canvas.toBlob((blob) => {
              // 在完成后销毁视频元素
              video?.destroy();
              const file = new File([blob], `cover_image_${randomString()}.png`, { type: "image/png" }); //转成file格式
              directUploadTencentCloud(file)
                .then((data) => {
                  const path = "https://" + data.Location;
                  resolve(path);
                })
                .catch((err) => {
                  console.log("directUploadTencentCloud error:", err);
                  resolve("");
                });
            });
          })
          .catch(() => {
            resolve("");
          });
      });
    },
    handleCancel() {
      this.$router.back();
    },
    deleteNameSuffix(name) {
      const index = name?.lastIndexOf(".");
      return index > -1 ? name.substr(0, index) : name;
    },
    handleNext() {
      this.$refs.ruleForm?.validate().then(() => {
        this.$nextTick(() => {
          const doneFileList = this.form.files.filter((item) => !item.status || item.status === "done");
          if (doneFileList.length === 0) {
            this.$message.warning(`请上传${this.coursewareText}`);
            return;
          }
          this.nextLoading = true;
          const filePromiseList = this.form.files.map(async (item, index) => {
            return {
              key: randomString(),
              rowIndex: index + 1,
              name: this.deleteNameSuffix(item.name),
              cover_image: this.form.courseware === 2 ? await this.getVideoCover(item.url) : item.url,
              content: item.url,
            };
          });
          Promise.all(filePromiseList).then((files) => {
            this.list = files;
            this.step = 2;
            this.nextLoading = false;
          });
        });
      });
    },
    handleConfirm() {
      this.$refs.ruleForm?.validate().then((valid) => {
        if (valid) {
          const list = this.list;
          if (list.length === 0) {
            this.$message.warning("列表数据不能为空");
          } else {
            for (let i = 0; i < list.length; i++) {
              const item = list[i];
              if (isEmpty(item.name)) {
                this.$message.warning(`请填写序号[${item.rowIndex}]的课程名称`);
                return;
              }
              if (!item.cover_image) {
                this.$message.warning(`请上传序号[${item.rowIndex}]的封面图`);
                return;
              }
              if (!item.content) {
                this.$message.warning(`请填写序号[${item.rowIndex}]的课程内容`);
                return;
              }
            }
            if (this.confirmLoading) return;
            this.confirmLoading = true;
            const form = this.form;
            this.$axios({
              url: "/admin/learn-course/batch-save-files",
              method: "POST",
              data: {
                courseware: form.courseware,
                identity: form.identity,
                learn_course_type_id: form.learn_course_type_id,
                is_recommend: form.is_recommend ? 1 : 2,
                data: this.list.map((item) => {
                  return {
                    name: item.name,
                    cover_image: item.cover_image,
                    content:
                      form.courseware === 4
                        ? JSON.stringify([{ name: item.name, url: item.cover_image }])
                        : item.content,
                  };
                }),
              },
            })
              .then((res) => {
                if (res.error === 0) {
                  this.$message.success("批量操作成功");
                  this.handleCancel();
                } else {
                  this.$message.error(res.msg);
                }
              })
              .finally(() => {
                this.confirmLoading = false;
              });
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.form-box {
  padding: 24px;
}
:deep(.ant-table-body) {
  background-color: #fff;
}
</style>
